import { render, staticRenderFns } from "./CallEnded.vue?vue&type=template&id=492ad806&scoped=true&"
import script from "./CallEnded.vue?vue&type=script&lang=js&"
export * from "./CallEnded.vue?vue&type=script&lang=js&"
import style0 from "./CallEnded.vue?vue&type=style&index=0&id=492ad806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492ad806",
  null
  
)

export default component.exports